import {Component, OnInit} from '@angular/core';
import {BreadcrumbsService} from '../../shared/components/breadcrumbs/breadcrumbs.service';

@Component({
  selector: 'kkk-planted-churches',
  templateUrl: './planted-churches.component.html'
})
export class PlantedChurchesComponent implements OnInit {
    constructor(
        private _breadcrumbs: BreadcrumbsService,
    ) {
    }

    ngOnInit() {
        this._breadcrumbs
            .start({name: 'Mit teszünk?', instructions: ['/mit-teszunk']})
            .add({name: 'Missziók', instructions: ['/missziok']})
            .add({name: 'Plántált gyülekezeteink'});
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/planted-churches/planted-churches.component.ts